import useSwitchService from '@hooks/useSwitchService';
import React from 'react';
import GnbCheckerBoardMenuPresenter from './GnbCheckerBoardMenuPresenter';

const GnbCheckerBoardMenuContainer: React.FC = () => {
  const { handleSwitchService } = useSwitchService();

  return (
    <GnbCheckerBoardMenuPresenter handleSwitchService={handleSwitchService} />
  );
};

export default GnbCheckerBoardMenuContainer;
